import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/system";
import "./duvidas-frequentes.scss";

const RoundedAccordion = styled(Accordion)(() => ({
  borderRadius: "8px",
  overflow: "hidden",
  "&:before": {
    display: "none",
  },
}));

export default function DuvidasFrequentes() {
  return (
    <>
      <Grid className="item-faq" size={12} sx={{ mb: 2 }}>
        <RoundedAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="titulo-item-faq"
            id="panel1a-header">
            <Typography variant="h3">
              Preciso ter limite disponível no cartão de crédito?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="descricao">
              Sim! Para parcelar com a Quita, você precisa ter o valor total da
              operação disponível no limite do seu cartão. Importante: o limite
              é comprometido em uma única vez, no momento da contratação. Mas o
              pagamento será feito parcelado na fatura do seu cartão, conforme a
              quantidade de parcelas escolhida. Ou seja: você paga aos poucos,
              mas o banco precisa garantir o valor total disponível no limite.
            </Typography>
          </AccordionDetails>
        </RoundedAccordion>
      </Grid>

      <Grid className="item-faq" size={12} sx={{ mb: 2 }}>
        <RoundedAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="titulo-item-faq"
            id="panel1a-header">
            <Typography variant="h3">Quita Boletos é confiável?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="descricao">
              Sim, a Quita Boletos é totalmente confiável. Nosso sistema{" "}
              <strong>utiliza diversas etapas de segurança,</strong> como
              biometria e antifraude, para proteger suas transações. Todas as
              informações fornecidas são criptografadas de ponta a ponta,
              garantindo total confidencialidade durante o processo de
              contratação. Além disso, empregamos mecanismos avançados para
              assegurar a segurança dos seus dados.
            </Typography>
          </AccordionDetails>
        </RoundedAccordion>
      </Grid>

      <Grid className="item-faq" size={12} sx={{ mb: 2 }}>
        <RoundedAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="titulo-item-faq"
            id="panel1a-header">
            <Typography variant="h3">
              Por que preciso informar meus dados pessoais na contratação?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="descricao">
              Solicitamos seus dados pessoais para garantir a total segurança da
              operação, tanto para a Quita Boletos quanto para você, o
              contratante. Isso nos permite validar a transação de forma segura.
            </Typography>
          </AccordionDetails>
        </RoundedAccordion>
      </Grid>

      <Grid className="item-faq" size={12} sx={{ mb: 2 }}>
        <RoundedAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="titulo-item-faq"
            id="panel1a-header">
            <Typography variant="h3">
              Qual o prazo para meus débitos serem quitados?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="descricao">
              Nosso prazo médio para quitação dos débitos é de apenas algumas
              horas. No entanto, em alguns casos, pode levar até 48 horas úteis
              após a autorização da transação.
            </Typography>
          </AccordionDetails>
        </RoundedAccordion>
      </Grid>

      <Grid className="item-faq" size={12} sx={{ mb: 2 }}>
        <RoundedAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="titulo-item-faq"
            id="panel1a-header">
            <Typography variant="h3">
              Existem limites para a contratação?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="descricao">
              Sim, o valor máximo para contratação é de R$ 10.000,00.
            </Typography>
            <Typography className="descricao">
              Se precisar de um valor maior, você pode realizar mais de uma
              operação ou entrar em contato conosco para assistência.
            </Typography>
          </AccordionDetails>
        </RoundedAccordion>
      </Grid>

      <Grid className="item-faq" size={12} sx={{ mb: 2 }}>
        <RoundedAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="titulo-item-faq"
            id="panel1a-header">
            <Typography variant="h3">
              Quais tipos de boleto posso parcelar?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="descricao">
              Você pode parcelar <strong>PIX</strong> ou{" "}
              <strong>contas de luz</strong>, <strong>água</strong>,
              <strong> telefone</strong>, <strong> aluguel</strong>,
              <strong> condomínio</strong>,{" "}
              <strong>prestação do carro ou moto</strong>,{" "}
              <strong>impostos</strong>, entre outros.
            </Typography>
          </AccordionDetails>
        </RoundedAccordion>
      </Grid>

      <Grid className="item-faq" size={12} sx={{ mb: 2 }}>
        <RoundedAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="titulo-item-faq"
            id="panel1a-header">
            <Typography variant="h3">
              Posso usar o cartão de outra pessoa?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="descricao">
              Não é possível. Para seguir com o parcelamento, o cadastro no site
              e o cartão de crédito precisam estar no mesmo nome. Ah, e atenção:
              os dados devem estar preenchidos corretamente — isso ajuda a
              garantir a segurança da operação e a aprovação mais rápida
            </Typography>
          </AccordionDetails>
        </RoundedAccordion>
      </Grid>

      <Grid className="item-faq" size={12} sx={{ mb: 2 }}>
        <RoundedAccordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            className="titulo-item-faq"
            id="panel1a-header">
            <Typography variant="h3">Como funciona o Pix parcelado?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography className="descricao">
              Na Quita, parcelar seu Pix é simples.
            </Typography>
            <Typography className="descricao" sx={{ my: 2 }}>
              Você escolhe o valor do pagamento, realiza a simulação em nosso
              site, informando os dados necessários e selecionando o número de
              parcelas desejado.
            </Typography>
            <Typography className="descricao">
              Após a aprovação, a Quita Boletos realiza o pagamento do Pix à
              vista, e você quita o valor em parcelas diretamente no cartão de
              crédito. É uma solução prática, segura e flexível para organizar
              suas finanças.
            </Typography>
          </AccordionDetails>
        </RoundedAccordion>
      </Grid>
    </>
  );
}
